var styleDataHash = "ad8e7bc7";
const injectCss = () => {
  var css = `.TR-Ed{display:block!important}[dir] .TR-Ed{margin:12px 0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var figure_default = {
  "figure": "TR-Ed"
};
export {
  figure_default as default,
  injectCss
};
//# sourceMappingURL=figure-scss.js.map
